module.exports = __webpack_public_path__ + "ipetbooking/admin/img/login_logo.8ecb94a4.svg";